<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Terms" pageTitle="Terms" />
            <TermsContent />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import TermsContent from '../Terms/TermsContent'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'TermsPage',
    components: {
        MainHeader,
        PageTitle,
        TermsContent,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>